<!--  -->
<template>
  <div class="obdwr">
    <div class="jawewr">
      <div class="inwerbox">
        <div class="inaweqw">
          <div class="keuwename">客服组id/名称：</div>
          <el-input
            v-model="query.keywords"
            class="kewrweer"
            placeholder="请输入内容"
          />
        </div>
        <div class="inaweqw">
          <div class="keuwename">企业id/名称：</div>
          <el-input
            v-model="query.corp"
            class="kewrweer"
            placeholder="请输入内容"
          />
        </div>
        <div class="inaweqw">
          <div class="keuwename">广告主id：</div>
          <el-input
            v-model="query.account_id"
            class="kewrweer"
            placeholder="请输入内容"
          />
        </div>
        <div class="inaweqw">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="search"
          >搜索</el-button>
        </div>
        <div class="inaweqw">
          <el-button
            type="info"
            icon="el-icon-refresh"
            size="small"
            @click="reset"
          >重置</el-button>
        </div>
      </div>
      <div>
        <!-- <el-button
          type="info"
          icon="el-icon-plus"
          size="small"
          @click="addcustrom"
        >新建客服组</el-button> -->
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      :header-cell-style="{ background: '#f0f0f0',color:'#81848a' }"
    >
      <el-table-column
        prop="group_id"
        label="客服组ID"
        width="130"
        align="center"
      />
      <el-table-column
        prop="group_name"
        label="客服组名称"
        width="130"
        align="center"
      />
      <el-table-column
        prop="set_name"
        label="客服集名称"
        width="300"
        align="center"
      >
        <template slot-scope="scope">
          <div
            style="max-height: 80px; overflow-y: auto; padding-right: 5px;"
          >
            <el-tag
              style="margin: 3px"
              v-for="(item, index) in scope.row.set_names"
              :key="index"
            >
              {{ item }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="corp_id"
        label="企业ID"
        width="330"
        align="center"
      />
      <el-table-column
        prop="corp_name"
        label="企业名称"
        width="200"
        align="center"
      />
      <el-table-column
        prop="account_id"
        label="广告主ID"
        width="200"
        align="center"
      />
      <el-table-column
        prop="address"
        label="客服组客服"
        align="center"
        width="350"
      >
        <template slot-scope="scope">
          <div
            style="max-height: 80px; overflow-y: auto;"
          >
            <el-tag
              :key="index"
              v-for="item,index in scope.row.user_names"
              style="margin: 3px"
            >{{ item }},</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="点击/添加"
        align="center"
        width="250"
      >
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.click_add_number"
            style="width: 200px"
            @focus="storeOriginalValue(scope.row)"
            @blur="cmtAddNumber(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="间隔时长（分钟）"
        align="center"
        width="250"
      >
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.estimated_max_time"
            style="width: 200px"
            @focus="storeOriginalValue2(scope.row)"
            @blur="cmtAddNumber2(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <!-- <el-button
            type="text"
            @click="detail(scope.row.id)"
          >详情</el-button> -->
          <el-button
            type="text"
            @click="edit(scope.row)"
          >编辑</el-button>
          <!-- <el-button
            type="text"
            style="color:#F56C6C"
            @click="deleter(scope.row.id)"
          >删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="客服组"
      :visible.sync="custromdialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
      width="50%"
    >
      <addcustemdialog
        ref="addcustemdialogview"
        @updata="updata"
      />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import addcustemdialog from './components/addcustemdialog.vue'
import { getcorpcsgrouplist, updateClickAddNumber, updateEstimatedMaxTime } from '@/api/dataReport.js'
export default {
  components: { PaginationRight, addcustemdialog },
  data() {
    return {
      tableData: [],
      input: '',
      query: {
        page: 1,
        pageSize: 10,
        keywords: '',
        forward_url: btoa('internal/ad/getCorpCsGroupList'),
        corp: null,
        account_id: null
      },
      total: null,
      custromdialog: false,
      loading: false
    }
  },
  created() {
    this.list()
  },
  mounted() {},
  methods: {
    list() {
      this.loading = true
      getcorpcsgrouplist(this.query)
        .then(res => {
          console.log('res', res)
          this.tableData = res.data.list
          this.total = res.data.total
          this.loading = false
        })
        .catch(err => {
          console.log('err', err)
          this.loading = false
        })
    },
    detail() {},
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    addcustrom() {
      this.custromdialog = true
      this.$nextTick(() => {
        this.$refs.addcustemdialogview.send(1)
      })
    },
    updata() {
      this.custromdialog = false
      this.list()
    },
    search() {
      this.query.page = 1
      this.list()
    },
    reset() {
      this.query.page = 1
      this.query.keywords = ''
      this.query.corp = ''
      this.query.account_id = ''
      this.list()
    },
    edit(item) {
      console.log(item)
      this.custromdialog = true
      this.$nextTick(() => {
        this.$refs.addcustemdialogview.send(2, item)
      })
    },
    // deleter(employee_no) {
    //   this.$confirm('确定要删除吗, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     closeOnClickModal: false,
    //     type: 'warning'
    //   })
    //     .then(() => {
    //       setNumberindexdelete(employee_no).then(res => {
    //         this.$message({
    //           type: 'success',
    //           message: '删除成功!'
    //         })
    //         this.list()
    //       })
    //     })
    //     .catch(() => {
    //       // this.$message({
    //       //   type: 'info',
    //       //   message: '已取消删除'
    //       // })
    //     })
    // },
    cmtAddNumber(val) {
      console.log(val)
      const num = Number(val.click_add_number)
      if (Number.isInteger(num) && num > 0) {
        // eslint-disable-next-line eqeqeq
        if (val.click_add_number != val._original_click_add_number) {
          this.$confirm('值已修改，是否提交', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            console.log('值已变化，提交:', val.click_add_number)
            // 这里调用接口提交 row.click_add_number
            updateClickAddNumber({
              id: val.id,
              click_add_number: num,
              forward_url: btoa('internal/ad/updateClickAddNumber')
            }).then(res => {
              this.$message({
                type: 'success',
                message: '提交修改成功!'
              })
              this.list()
            })
            // 更新原始值
            val._original_click_add_number = val.click_add_number
          })
        } else {
          this.$message.info('修改未提交,值未变化')
        }
      } else {
        this.$message.error('修改未提交,请输入正确的数字!')
      }
    },
    cmtAddNumber2(val) {
      console.log(val)
      const num = Number(val.estimated_max_time)
      if (Number.isInteger(num) && num > 0) {
        // eslint-disable-next-line eqeqeq
        if (val.estimated_max_time != val._estimated_max_time) {
          this.$confirm('值已修改，是否提交', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            console.log('值已变化，提交:', val.estimated_max_time)
            // 这里调用接口提交 row.click_add_number
            updateEstimatedMaxTime({
              id: val.id,
              estimated_max_time: num,
              forward_url: btoa('internal/ad/updateEstimatedMaxTime')
            }).then(res => {
              this.$message({
                type: 'success',
                message: '提交修改成功!'
              })
              this.list()
            })
            // 更新原始值
            val._estimated_max_time = val.estimated_max_time
          })
        } else {
          this.$message.info('修改未提交,值未变化')
        }
      } else {
        this.$message.error('修改未提交,请输入正确的数字!')
      }
    },
    storeOriginalValue(row) {
      if (row._original_click_add_number === undefined) {
        row._original_click_add_number = row.click_add_number
      }
    },
    storeOriginalValue2(row) {
      if (row._estimated_max_time === undefined) {
        row._estimated_max_time = row.estimated_max_time
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.obdwr {
  padding: 30px;
}
.keuwename {
  color: #a4a9b1;
  font-size: 15px;
}
.kewrweer {
  width: 200px;
}
.inaweqw {
  display: flex;
  align-items: center;
  margin-right: 15px;
}
.inwerbox {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.jawewr {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
